export default __webpack_public_path__ + "static/media/solflare.ee51fb40.svg";